import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Row} from "reactstrap";
import {CONTROLLER} from "../../../../constants/appConstants";
import {requestAquaticGroupProfiles} from "../../../../redux/Actions/toolsTab.action";
import {getAquaticGroupProfiles} from "../../../../redux/Selectors/toolsTab.selector";
import AquaticProfileCard from "./aquaticProfileCard";

const AquaticProfiles = () => {
  const dispatch = useDispatch();
  const groupProfiles = useSelector(getAquaticGroupProfiles);
  useEffect(() => {
    dispatch(requestAquaticGroupProfiles());
  }, [dispatch]);

  return (
    <div>
      <div className={"sectionLabelSpacing sectionLabel roboto-bold"}>
        {CONTROLLER.TOOLS.AQUATIC_PROFILES}
      </div>
      {groupProfiles.length > 0 ? (
        <Row style={{margin: "10px"}}>
          {groupProfiles.map((profile, index) => {
            return <AquaticProfileCard key={index} profile={profile} />;
          })}
        </Row>
      ) : (
        <h1 style={{margin: "30px 0px", textAlign: "center"}}>
          No Group Profiles Present
        </h1>
      )}
    </div>
  );
};

export default AquaticProfiles;
